import React, { useState, useEffect } from 'react';
import { FileText, Download, Search, Upload, Trash2, Loader2 } from 'lucide-react';

export default function AdminDokumente() {
  const [documents, setDocuments] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [isUploading, setIsUploading] = useState(false);

  useEffect(() => { fetchDocuments(); }, []);

  const fetchDocuments = async () => {
    try {
      const token = localStorage.getItem('admin_token');
      const response = await fetch('/api/admin/documents', { headers: { 'Authorization': `Bearer ${token}` } });
      if (response.ok) setDocuments(await response.json());
    } catch (err) { console.error(err); } finally { setIsLoading(false); }
  };

  const handleUpload = async (e) => {
    const file = e.target.files[0];
    if (!file) return;
    setIsUploading(true);
    const formData = new FormData();
    formData.append('file', file);

    try {
      const token = localStorage.getItem('admin_token');
      const response = await fetch('/api/admin/documents', {
        method: 'POST',
        headers: { 'Authorization': `Bearer ${token}` },
        body: formData
      });
      if (response.ok) {
        fetchDocuments();
      } else {
        alert("Fehler beim Hochladen.");
      }
    } catch (err) { console.error(err); } finally { setIsUploading(false); }
  };

  const handleDelete = async (id) => {
    if (!window.confirm("Dokument wirklich löschen?")) return;
    try {
      const token = localStorage.getItem('admin_token');
      const response = await fetch(`/api/admin/documents/${id}`, {
        method: 'DELETE',
        headers: { 'Authorization': `Bearer ${token}` }
      });
      if (response.ok) {
        setDocuments(docs => docs.filter(d => d.id !== id));
      }
    } catch (err) { console.error(err); }
  };

  return (
    <div className="animate-in fade-in slide-in-from-bottom-4">
      <div className="flex flex-col sm:flex-row justify-between items-start sm:items-center gap-4 mb-8">
        <div>
          <h1 className="text-2xl font-bold text-primary">Dokumente & Vorlagen</h1>
          <p className="text-muted-foreground">Verwalten Sie allgemeine Dokumente, NDAs und Richtlinien.</p>
        </div>
        
        <label className="bg-primary text-white px-4 py-2.5 rounded-md font-medium hover:bg-secondary transition-colors flex items-center gap-2 cursor-pointer shadow-sm">
          {isUploading ? <Loader2 className="w-4 h-4 animate-spin" /> : <Upload className="w-4 h-4" />} 
          {isUploading ? 'Lädt hoch...' : 'Dokument Hochladen'}
          <input type="file" className="hidden" onChange={handleUpload} />
        </label>
      </div>

      {isLoading ? (
        <div className="flex justify-center items-center h-64"><Loader2 className="w-8 h-8 animate-spin text-accent" /></div>
      ) : documents.length === 0 ? (
        <div className="bg-white rounded-xl border border-border p-12 text-center text-muted-foreground">
          Keine Dokumente hochgeladen. Nutzen Sie den Button oben rechts, um Dateien hinzuzufügen.
        </div>
      ) : (
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {documents.map((doc) => (
            <div key={doc.id} className="bg-white border border-border rounded-xl p-6 shadow-sm hover:shadow-md transition-shadow group flex flex-col">
              <div className="flex items-start justify-between mb-4">
                <div className="w-12 h-12 bg-accent/10 rounded-lg flex items-center justify-center text-accent">
                  <FileText className="w-6 h-6" />
                </div>
                <button onClick={() => handleDelete(doc.id)} className="text-slate-400 hover:text-red-500 opacity-0 group-hover:opacity-100 transition-opacity p-2">
                  <Trash2 className="w-4 h-4" />
                </button>
              </div>
              
              <h3 className="font-semibold text-primary mb-1 truncate" title={doc.name}>
                {doc.name}
              </h3>
              <div className="text-sm text-muted-foreground flex items-center justify-between mt-auto pt-4">
                <span>{doc.size} • {doc.type}</span>
                <span>{doc.upload_date}</span>
              </div>
              
              <a href={doc.url} download target="_blank" rel="noopener noreferrer" className="mt-4 w-full py-2 bg-slate-50 hover:bg-slate-100 border border-border rounded-md text-sm font-medium text-secondary flex items-center justify-center gap-2 transition-colors">
                <Download className="w-4 h-4" /> Herunterladen
              </a>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}